module.exports = __webpack_public_path__ + "img/Singapore-4-hover.af5910da.jpg";